import {createSlice} from '@reduxjs/toolkit';
import {changeDeliveryDate} from '../actions/deliveryDateForm';

const initialState = {
    success: false,
    isLoading: false,
    hasError: false,
    errorMessage: '',
};

const deliveryDateFormSlice = createSlice({
    name: 'deliveryDateForm',
    initialState,
    reducers: {
        resetChangeDeliveryDateDialog: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(changeDeliveryDate.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(changeDeliveryDate.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = true;
            })
            .addCase(changeDeliveryDate.rejected, (state, action) => {
                state.isLoading = false;
                state.success = false;
                state.hasError = true;
                state.errorMessage = action.payload.errorMessage;
            });
    },
});

export const {resetChangeDeliveryDateDialog} = deliveryDateFormSlice.actions;
export default deliveryDateFormSlice.reducer;
